<template>
  <v-layout align-center justify-center row fill-height>
    <div style="text-align: center">
      <h1 style="font-weight: bold" class="display-4">404</h1>
      <h6 class="title">{{ $t('views.notFound.pageNotFound') }}</h6>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>
